const parcdeschutes = {
  header_full_height: true,
  number_hidden: true,
  title_font: `'Sen', sans-serif`,
  text_font: `'Sen', sans-serif`,
  text_size: 16,
  text_lineheight: 23,
}

export const parcdeschutes_bleu = {
  ...parcdeschutes,
  body_background_color: '#1e73be',
  logo_image_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-0-parcdeschutes_bleu-au7i78c.png?alt=media&token=a74bfcfa-08b8-4679-9c54-c49251ccdafd',
  token_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-3-parcdeschutes_bleu-48qsg3i.png?alt=media&token=21012f36-fd53-417e-bdc9-b5dc3a44456e',
  button_color: '#1e73be',
}

export const parcdeschutes_jaune = {
  ...parcdeschutes,
  body_background_color: '#E7BD51',
  logo_image_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-1-parcdeschutes_jaune-2dydcls.png?alt=media&token=b106e86b-d4e6-4834-9a80-143b95c99f32',
  token_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-4-parcdeschutes_jaune-v8e4xv0.png?alt=media&token=e2da0ff7-5ca8-48b4-bf2d-13ef9d7de453',
  button_color: '#E7BD51',
}

export const parcdeschutes_vert = {
  ...parcdeschutes,
  body_background_color: '#9BC67F',
  logo_image_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-2-parcdeschutes_vert-v6yjo6c.png?alt=media&token=a7b8c53a-2b78-4a5b-88be-3b923490901e',
  token_url:
    'https://firebasestorage.googleapis.com/v0/b/smartjourney-app.appspot.com/o/apps%2Fparcdeschutesapp%2F8jvD0aqDh-5-parcdeschutes_vert-2gyqkt6.png?alt=media&token=1554a72f-cc4e-49e5-92af-6c735e265bd6',
  button_color: '#9BC67F',
}
